export const TEST_ID = 'batteryStatusMenu';
